<template>
  <span data-id="value">{{ value }}</span>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{ length?: number }>(), { length: 0 });
const value = computed(() => {
  const m = 1000;
  const size = props.length;
  if (!size) {
    return '';
  } else if (size >= m ** 2) {
    const mb = size / m / m;
    return mb.toFixed(1) + ' MB';
  } else if (size >= m) {
    const kb = size / m;
    return kb.toFixed(0) + ' KB';
  } else {
    return size.toFixed(0) + ' B';
  }
});
</script>
